export var newsInfo = {
    items: [
        {
            title: "Building Owners are Seeing Benefits from Detailed As-Built Information",
            date: "2026-05-01",
            type: "news",
            target: "_blank",
            url: "/news/2026/1-1-May-Benifits-of-As-Built-Information.pdf",
            shortDescription: "Building performance standards across the U.S. are pushing owners to manage compliance as an ongoing process, not a one-time report.<br>Accurate, continuously maintained as-built data for roofing, walls, fenestration, paving, and elevators improves modeling, reporting, retrofit planning, and audit readiness.<br>This announcement highlights why mission-built facilities software helps reduce risk and improve decisions.",
        },
        {
            title: "Steven James Featured on Facility Voices Podcast",
            date: "2025-12-29",
            type: "event",
            shortDescription: "Steven James a Principal of Digital Facilities, is interviewed by David Trask on the Facility Voices Podcast, discussing the topic of commercial roof management. Steven answers a wide range of questions from Mr. Trask on all aspects of managing roofing on public institutions from his experience managing a roofing manufacturing division to developing a 20+ year technology firm providing services to leading schools and universities.<br><br><a href=\"https://www.arcfacilities.com/podcast/raising-the-roof-proactive-strategies-for-smarter-roof-management\" target=\"_blank\" rel=\"noopener noreferrer\">Listen to the Facility Voices Podcast</a>",
        },
        {
            title: "Digital Facilities Awarded Five-Year Technology Agreement",
            date: "2025-09-17",
            type: "news",
            shortDescription: "Aggrements run until 06-30-2029. Digital Facilities was awarded a five-year technology agreement to provide Elevator management SaaS services to MHEC members under the MC15-G28 Elevators Equipment and Services.",
        },
        {
            title: "Digital Facilities will be attending the MEHEC EXPO",
            date: "2025-09-15",
            type: "event",
            shortDescription: "September 15-2025 Digital Facilities will be attending the MEHEC EXPO on Thursday. Join us at this important industry event to learn about our latest building management solutions and innovations.",
        },
        {
            titleImg: "/img/news/fm.png",
            title: "FMPro™ Copy Roof Section Detail Records",
            date: "2024-11-10",
            type: "release",
            target: "_blank",
            url: "/news/2024/10-Nov-FMPro-Copy-Roof-Section-Details.pdf",
            shortDescription: "ACTON, MA (Nov 2024) Digital Facilities Corporation (DFC) has released a set of program updates for FMPro™ a Building Management solution for comprehensive asset management of Roofing, Façade, Paving, and Vertical transportation equipment...",
        },
        {
            titleImg: "/img/news/fm.png",
            title: "FMPro™ Addition of Roof System Information in FCR",
            date: "2024-07-24",
            type: "release",
            target: "_blank",
            url: "/news/2024/9-24-Jul-FMPro-Roof-System-added-to-FCR.pdf",
            shortDescription: "ACTON, Mass (July 2024) Digital Facilities Corporation (DFC) has released a set of program updates for FMPro™ a Building Management solution for comprehensive asset management of Roofing, Façade, Paving, and Vertical transportation equipment...",
        },
        {
            titleImg: "/img/news/fm.png",
            title: "FMPro™ Defect Status Enhancement",
            date: "2024-07-24",
            type: "release",
            target: "_blank",
            url: "/news/2024/8-24-Jul-FMPro-Defect-Status-Enhancement.pdf",
            shortDescription: "ACTON, Mass (July 2024) Digital Facilities Corporation (DFC) has released a set of program updates for FMPro™ a Building Management solution for comprehensive asset management of Roofing, Façade, Paving, and Vertical transportation equipment...",
        },
        {
            titleImg: "/img/news/fm.png",
            title: "FMPro™ Defect Status Enhancement",
            date: "2024-07-18",
            type: "release",
            target: "_blank",
            url: "/news/2024/7-18-Jul-FMPro-Report-Template-Enhancement.pdf",
            shortDescription: "ACTON, Mass (July 2024) Digital Facilities Corporation (DFC) has released a set of program updates for FMPro™ a Building Management solution for comprehensive asset management of Roofing, Façade, Paving, and Vertical transportation equipment...",
        },
        {
            titleImg: "/img/news/fm.png",
            title: "FMPro™ Template Report Improvements",
            date: "2024-07-16",
            type: "release",
            target: "_blank",
            url: "/news/2024/6-16-Jul-FMPro-FCR-Report-Processing.pdf",
            shortDescription: "ACTON, MA (July 2024) Digital Facilities Corporation (DFC) has released a set of program updates for FMPro™ a Building Management solution for comprehensive asset management of Roofing, Façade, Paving, and Vertical transportation equipment...",
        },
        {
            titleImg: "/img/news/fm.png",
            title: "FMPro™ Custom Dashboard Option Added",
            date: "2024-07-10",
            type: "release",
            target: "_blank",
            url: "/news/2024/5-10-Jul-FMPro-Custom-Dashboard-Image-Option.pdf",
            shortDescription: "ACTON, Mass (July 2024) Digital Facilities Corporation (DFC) has released a set of program updates for FMPro™ a Building Management solution for comprehensive asset management of Roofing, Façade, Paving, and Vertical transportation equipment...",
        },
        {
            titleImg: "/img/news/fm.png",
            title: "FMPro™ Template Report Cover Letter Management",
            date: "2024-07-03",
            type: "release",
            target: "_blank",
            url: "/news/2024/4-3-Jul-FMPro-Template-cover-letter-Management.pdf",
            shortDescription: "ACTON, Mass (July 2024) Digital Facilities Corporation (DFC) has released a set of program updates for FMPro™ a Building Management solution for comprehensive asset management of Roofing, Façade, Paving, and Vertical transportation equipment...",
        },
        {
            titleImg: "/img/news/fm.png",
            title: "FMPro™ New Reporting Options",
            date: "2024-05-24",
            type: "release",
            target: "_blank",
            url: "/news/2024/3-24-May-FMPro-New-Reporting-Options.pdf",
            shortDescription: "ACTON, Mass (May 2024) Digital Facilities Corporation (DFC) has released a set of program updates for FMPro™ a Building Management solution for comprehensive asset management of Roofing, Façade, Paving, and Vertical transportation equipment...",
        },
        {
            titleImg: "/img/news/fm.png",
            title: "FMPro™ FCR Report Image Insertion Enhancement",
            date: "2024-01-24",
            type: "release",
            target: "_blank",
            url: "/news/2024/2-24-Jan-FMPro-FCR-Image-Area-Enhancement.pdf",
            shortDescription: "ACTON, Mass (January 2024) Digital Facilities Corporation (DFC) has released a set of program updates for FMPro™ a specialized Building Envelope Management solution for comprehensive asset management of Roofing, Façade, Paving and Vertical transportation equipment...",
        },
        {
            titleImg: "/img/news/fm.png",
            title: "FMPro™ SMART TEXT ™ Library",
            date: "2024-01-01",
            type: "release",
            target: "_blank",
            url: "/news/2024/1-1-Jan-FMPro-Smart-Text-Library.pdf",
            shortDescription: "ACTON, Mass (January 2024) Digital Facilities Corporation (DFC) has released a set of program updates for FMPro™ a specialized Building Envelope Management solution for comprehensive asset management of Roofing, Façade, Paving and Vertical transportation equipment...",
        },
        {
            titleImg: "/img/news/fm.png",
            title: "FMPro™ Search Feature Release",
            date: "2023-03-01",
            type: "release",
            target: "_blank",
            url: "/news/2023-1/7-FMPro-Search-Feature-Release-3-23.pdf",
            shortDescription: "ACTON, Mass (March 2023) Digital Facilities Corporation (DFC) has released a set of program updates for FMPro™ a specialized Building Envelope Management solution for comprehensive asset management of Roofing, Façade, Paving and Vertical transportation equipment...",
        },
        {
            titleImg: "/img/news/fm.png",
            title: "FMPro™ Copy of Inspection Records",
            date: "2023-03-01",
            type: "release",
            target: "_blank",
            url: "/news/2023-1/7-FMPro-Copy-Inspection-Records-3-23.pdf",
            shortDescription: "ACTON, Mass (March 2023) Digital Facilities Corporation (DFC) has released a set of program updates for FMPro™ a specialized Building Envelope Management solution for comprehensive asset management of Roofing, Façade, Paving and Vertical transportation equipment...",
        },
        {
            titleImg: "/img/news/fm.png",
            title: "FMPro™ Work History Report Enhancements",
            date: "2023-02-01",
            type: "release",
            target: "_blank",
            url: "/news/2023-1/6-FMPro-Work-History-Reports-Release-2-23.pdf",
            shortDescription: "ACTON, Mass (February 2023) Digital Facilities Corporation (DFC) has released a set of program updates for FMPro™ a specialized Building Envelope Management solution for comprehensive asset management of Roofing, Façade, Paving and Vertical transportation equipment...",
        },
        {
            titleImg: "/img/news/fm.png",
            title: "FMPro™ Recommendations Report Filter Enhancements",
            date: "2023-01-01",
            type: "release",
            target: "_blank",
            url: "/news/2023-1/6-FMPro-Recomendations-Report-filter-Enhancement-Release-1-23.pdf",
            shortDescription: "ACTON, Mass (January 2023) Digital Facilities Corporation (DFC) has released a set of program updates for FMPro™ a specialized Building Envelope Management solution for comprehensive asset management of Roofing, Façade, Paving and Vertical transportation equipment...",
        },
        {
            titleImg: "/img/news/fm.png",
            title: "FMPro™ Facility Asset & Budget Summary Report",
            date: "2022-12-01",
            type: "release",
            target: "_blank",
            url: "/news/2023-1/5-FMPro-Facility-Asset&Budget-Summary-Report-Release-12-22.pdf",
            shortDescription: "ACTON, Mass (December 2022) Digital Facilities Corporation (DFC) has released a set of program updates for FMPro™ a specialized Building Envelope Management solution for comprehensive asset management of Roofing, Façade, Paving and Vertical transportation equipment...",
        },
        {
            titleImg: "/img/news/fm.png",
            title: "FMPro™ Work History Dynamic Viewing Option",
            date: "2022-11-01",
            type: "release",
            target: "_blank",
            url: "/news/2023-1/4-FMPro-Work-History-Dynamic-Viewing-Enhancement-Release-11-22.pdf",
            shortDescription: "ACTON, Mass (November 2022) Digital Facilities Corporation (DFC) has released a set of program updates for FMPro™ a specialized Building Envelope Management solution for comprehensive asset management of Roofing, Façade, Paving and Vertical transportation equipment...",
        },
        {
            titleImg: "/img/news/fm.png",
            title: "FMPro™ Budget Summary Report Enhancements",
            date: "2022-11-01",
            type: "release",
            target: "_blank",
            url: "/news/2023-1/4-FMPro-Budget-Summary-Report-Enhancement-Release-11-22.pdf",
            shortDescription: "ACTON, Mass (October 2022) Digital Facilities Corporation (DFC) has released a set of program updates for FMPro™ a specialized Building Envelope Management solution for comprehensive asset management of Roofing, Façade, Paving and Vertical transportation equipment...",
        },
        {
            titleImg: "/img/news/fm.png",
            title: "FMPro™ Roofing Section Roof/Recommendation Report",
            date: "2022-04-01",
            type: "release",
            target: "_blank",
            url: "/news/2023-1/3-FMPro-Roof-Recomendation-Report-Update-Release-4-22.pdf",
            shortDescription: "ACTON, Mass (April 2022) Digital Facilities Corporation (DFC) has released a set of program updates for FMPro™ a specialized Building Envelope Management solution for comprehensive asset management of Roofing, Façade, Paving and Vertical transportation equipment...",
        },
        {
            titleImg: "/img/news/fm.png",
            title: "FMPro™ Google Maps Filter Enhancements",
            date: "2022-03-01",
            type: "release",
            target: "_blank",
            url: "/news/2023-1/2-FMPro-Google-Maps-Filter-Update-Release-3-22.pdf",
            shortDescription: "ACTON, Mass (March 2022) Digital Facilities Corporation (DFC) has released a set of program updates for FMPro™ a specialized Building Envelope Management solution for comprehensive asset management of Roofing, Façade, Paving and Vertical transportation equipment...",
        },
        {
            titleImg: "/img/news/fm.png",
            title: "FMPro™ Text Editor Update",
            date: "2022-01-01",
            type: "release",
            target: "_blank",
            url: "/news/2023-1/1-FMPro-Text-Editor-Update-Release-1-22.pdf",
            shortDescription: "ACTON, Mass (January 2022) Digital Facilities Corporation (DFC) has released a set of program updates for FMPro™ a specialized Building Envelope Management solution for comprehensive asset management of Roofing, Façade, Paving and Vertical transportation equipment...",
        },
        {
            title: "GIS Tagging in Google Maps",
            date: "2021-11-01",
            type: "release",
            target: "_blank",
            url: "/news/GISTaggingInGoogleMaps1121.pdf",
            shortDescription: "ACTON, Mass (November 2021) Digital Facilities Corporation (DFC) has added a set of program updates for FMPro™ — a Building Envelope Management solution for asset assessments for Roofing, Façade, Paving and Vertical transportation equipment...",
        },
        {
            titleImg: "/img/news/fm.png",
            title: "FMPro™ Text Editor Addition",
            date: "2021-10-01",
            type: "release",
            target: "_blank",
            url: "/news/FMPro-Text-Editor-Addition-08-21.pdf",
            shortDescription: "ACTON, Mass (Oct 2021) Digital Facilities Corporation (DFC) has added a set of program updates for FMPro™ — a Building Envelope Management solution for asset assessments for Roofing, Façade, Paving and Vertical transportation equipment."
        },
        {
            titleImg: "/img/news/fm.png",
            title: "FMPro™ Report Updated Image Size Options",
            date: "2021-09-01",
            type: "release",
            target: "_blank",
            url: "/news/FMPro-Image-9-21.pdf",
            shortDescription: "ACTON, Mass (September 2021) Digital Facilities Corporation (DFC) has released a set of program updates for FMPro™ a Building Envelope Management solution for asset assessments for Roofing, Façade, Paving and Vertical transportation equipment...",
        },
        {
            titleImg: "/img/news/fm.png",
            title: "FMPro™ Roofing Section Copy Options",
            date: "2021-05-01",
            type: "release",
            target: "_blank",
            url: "/news/FMPro-Roofing-5-21.pdf",
            shortDescription: "ACTON, Mass (May 2021) Digital Facilities Corporation (DFC) has released a set of program updates for FMPro™ a Building Envelope Management solution for asset assessments for Roofing, Façade, Paving and Vertical transportation equipment...",
        },
        {
            titleImg: "/img/news/fm.png",
            title: "FMPro™ Facility Copy Options",
            date: "2021-04-01",
            type: "release",
            target: "_blank",
            url: "/news/FMPro-Facility-4-21.pdf",
            shortDescription: "ACTON, Mass (May 2021) Digital Facilities Corporation (DFC) has released a set of program updates for FMPro™ a Building Envelope Management solution for asset assessments for Roofing, Façade, Paving and Vertical transportation equipment...",
        },
        {
            titleImg: "/img/news/fm.png",
            title: "FMPro™ Adding Multiple Offices Locations",
            date: "2021-02-01",
            type: "release",
            target: "_blank",
            url: "/news/FMPro-Multiple-2-21.pdf",
            shortDescription: "ACTON, Mass (Feb 2021) Digital Facilities Corporation (DFC) has released a set of program updates for FMPro™ a Building Envelope Management solution for asset assessments for Roofing, Façade, Paving and Vertical transportation equipment...",
        },
        {
            titleImg: "/img/news/fm.png",
            title: "FMPro™ Budget Start Year Options",
            date: "2021-01-01",
            type: "release",
            target: "_blank",
            url: "/news/FMPro-Budget-1-21.pdf",
            shortDescription: "ACTON, Mass (Feb 2021) Digital Facilities Corporation (DFC) has released a set of program updates for FMPro™ a Building Envelope Management solution for asset assessments for Roofing, Façade, Paving and Vertical transportation equipment...",
        },
        {
            titleImg: "/img/news/fm.png",
            title: "FMPro™ Google Maps™ Drawing Tools Release",
            date: "2020-08-01",
            type: "release",
            target: "_blank",
            url: "/news/FMPro-google-map-drawing.pdf",
            shortDescription: "ACTON, Mass (August 2020) Digital Facilities Corporation (DFC) has released a new tool area for use with Google Maps™ for FMPro™ a Building Envelope Management solution for asset assessments with individual areas for Roofing, Façade, Paving and Vertical transportation equipment...",
        },
        {
            titleImg: "/img/news/fm.png",
            title: "FMPro™ Updated Template Design Release",
            date: "2020-08-01",
            type: "release",
            target: "_blank",
            url: "/news/FMPro-UpdateTableDesign.pdf",
            shortDescription: "ACTON, Mass (August 2020) Digital Facilities Corporation (DFC) has released an updated design to the Facility Condition Report template for FMPro™ a Building Envelope Management solution for asset assessments with individual areas for Roofing, Façade, Paving and Vertical transportation equipment...",
        },
        {
            titleImg: "/img/news/fm.png",
            title: "FMPro™ Merge or Link PDF Documents Release",
            date: "2020-08-01",
            type: "release",
            target: "_blank",
            url: "/news/FMPro-Merge-or-Link-PDF-Documents-Release.pdf",
            shortDescription: "ACTON, Mass (August 2020) Digital Facilities Corporation (DFC) has released an updated design to the Facility Condition Report template for FMPro™ a Building Envelope Management solution for asset assessments with individual areas for Roofing, Façade, Paving and Vertical transportation equipment...",
        },
        {
            titleImg: "/img/news/fm.png",
            title: "FMPro™ New Attached File Management",
            date: "2019-06-01",
            type: "release",
            target: "_blank",
            url: "/news/RoofPro-FMPRO-Press-Release-6-19.1.pdf",
            shortDescription: "ACTON, Mass (June 2019) Digital Facilities Corporation (DFC) the industry’s leading supplier of Exterior Enclosure Assessment and Management Solutions, has released a major enhancement for the attached file area in the FMPro™ program platform first introduced in 2016...",
        },
        {
            titleImg: "/img/news/fm.png",
            title: "FMPro™ Roof System Recall",
            date: "2019-05-01",
            type: "release",
            target: "_blank",
            url: "/news/DFC-News-5-19.2.pdf",
            shortDescription: "ACTON, Mass (May 2019) Digital Facilities Corporation (DFC) the industry’s leading supplier of Building Exterior Management Solutions, is releasing a new tool option for saving complex roof systems with one click recall for auto filling the roofing system component descriptions with thickness, attachment, and insulation values...",
        },
        {
            titleImg: "/img/news/fm.png",
            title: "FMPro™ Document Viewer Update",
            date: "2019-04-01",
            type: "release",
            target: "_blank",
            url: "/news/DFC-News-5-19.1.pdf",
            shortDescription: "ACTON, Mass (April 2019) Digital Facilities Corporation (DFC) the industry’s leading supplier of Building Exterior Management Solutions, has released a document viewer enhancement for the new FMPro™ program platform introduced in 2016...",
        },
        {
            titleImg: "/img/news/fm.png",
            title: "FMPro™ Program Data Utility",
            date: "2018-08-01",
            type: "release",
            target: "_blank",
            url: "/news/RoofPro-FMPRO-PressRelease8-18.pdf",
            shortDescription: "ACTON, Mass (Aug 2018) Digital Facilities Corporation (DFC) the industry’s leading supplier of Building Exterior Management Solutions, has released a major enhancement for the new FMPro™ program platform introduced in 2016...",
        },
        {
            titleImg: "/img/news/r.png",
            title: "RoofPro™ Inspector 3.0 Updates",
            date: "2018-08-01",
            type: "release",
            target: "_blank",
            url: "/news/RoofPro-Inspector3.0-PressRelease8-18.pdf",
            shortDescription: "ACTON, Mass (August 2018) Digital Facilities Corporation (DFC) the industry’s leading supplier of Building Exterior Management Solutions, has released Window 10 updates for the Inspector program as part of the RoofPro™ series programs...",
        },
        {
            titleImg: "/img/news/r.png",
            title: "RoofPro™ Inspector 3.0 Updates",
            date: "2018-08-01",
            type: "release",
            target: "_blank",
            url: "/news/RoofPro-Inspector3.0-PressRelease8-18.pdf",
            shortDescription: "ACTON, Mass (August 2018) Digital Facilities Corporation (DFC) the industry’s leading supplier of Building Exterior Management Solutions, has released Window 10 updates for the Inspector program as part of the RoofPro™ series programs...",
        },
        {
            titleImg: "/img/news/r.png",
            title: "RoofPro R-2 new versions released",
            date: "2017-06-01",
            type: "release",
            target: "_blank",
            url: "/news/RoofPro-R2-PressRelease06.17.pdf",
            shortDescription: "ACTON, Mass (June 2017) Digital Facilities Corporation (DFC) the industry’s leading supplier of Building Exterior Management Solutions, has released a screen design update for the R-2 programs for the RoofPro™ series...",
        },
        {
            titleImg: "/img/news/r.png",
            title: "RoofPro Inspector 3.0 new version released",
            date: "2017-06-01",
            type: "release",
            target: "_blank",
            url: "/news/RoofPro-Inspector3.0-PressRelease6-17.pdf",
            shortDescription: "ACTON, Mass (June 2017) Digital Facilities Corporation (DFC) the industry’s leading supplier of Building Exterior Management Solutions, has released screen updates for the Inspector program as part of the RoofPro™ series programs...",
        },
        {
            titleImg: "/img/news/fm.png",
            title: "FM-Pro™ - new defect tracking",
            date: "2017-06-01",
            type: "release",
            target: "_blank",
            url: "/news/RoofPro-FMPRO-PressRelease6-17.pdf",
            shortDescription: "ACTON, Mass (June 2017) Digital Facilities Corporation (DFC) the industry’s leading supplier of Building Exterior Management Solutions, has released a major enhancements for the new FMPro™ program platform introduced in 2016...",
        },
        {
            titleImg: "/img/news/r.png",
            title: "RoofPro R-2 versions released",
            date: "2016-06-01",
            type: "release",
            target: "_blank",
            url: "/news/RoofPro-R2-Press-Release-06.16.pdf",
            shortDescription: "ACTON, Mass (June 2016) Digital Facilities Corporation (DFC) the industry’s leading supplier of Building Exterior Management Solutions, has released the R-2 programs for the RoofPro™ series...",
        },
        {
            titleImg: "/img/news/r.png",
            title: "RoofPro Inspector 3.0 version released",
            date: "2016-11-01",
            type: "release",
            target: "_blank",
            url: "/news/RoofPro-Inspector-3.0-Press-Release11.16.pdf",
            shortDescription: "ACTON, Mass (November 2016) Digital Facilities Corporation (DFC) the industry’s leading supplier of Building Exterior Management Solutions, has released a new Inspector program release as part of the RoofPro™ series programs..."
        },
        {
            titleImg: "/img/news/fm.png",
            title: "FM-Pro™ - New Quick Tour animation released",
            date: "2016-02-01",
            type: "release",
            target: "_blank",
            url: "//player.vimeo.com/video/152209186?autoplay=true",
            shortDescription: "Quick Tour animation video...",
        },
        {
            titleImg: "/img/news/r.png",
            title: "RoofPro™ Series - Service Updates Available",
            date: "2014-06-01",
            type: "release",
            target: "_blank",
            url: "/news/RoofPro-Series-Service-Updates-Available.pdf",
            shortDescription: "ACTON, Mass (Jan 2014) Digital Facilities Corporation (DFC) the industry’s leading supplier of Roof Management Solutions, has released program updates for RoofPro™ series programs...",
        },
        {
            titleImg: "/img/news/r.png",
            title: "RoofPro™ Series - Data Analysis Service",
            date: "2014-03-01",
            type: "release",
            target: "_blank",
            url: "/news/RoofPro-Series-Data-Analysis-Service.pdf",
            shortDescription: "ACTON, Mass (May 2014) Digital Facilities Corporation (DFC) the industry’s leading supplier of Roof Management Solutions, is offering data analysis for users with for RoofPro™ series programs...",
        },
        {
            title: "Service-Manager Pro™ - Daily Job Reporting",
            date: "2014-06-01",
            type: "release",
            target: "_blank",
            url: "/news/Service-Manager-Pro-Daily-Job-Reporting.pdf",
            shortDescription: "ACTON, Mass (Jun 2014) Digital Facilities Corporation (DFC) the industry’s leading supplier of Roof Management Solutions, is offering an extensive daily job reporting tool for Service Manager - Pro™ 3.0 programs...",
        }
    ]
}